import React from 'react';
import bannerImg from '../../../../src/assets/images/group-img.png';
import InfoSection from '../InfoSection';
import { QuickSectionStyle, BannerBlock } from './QuickSection.styles';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import { useStorybookContext } from '../../../Context/AppProvider';
import { notifyTourStatusChange } from '../../../hooks/useDummyData';
import Button from '../../molecules/Button';

function QuickSection() {
  const { setState } = useStorybookContext();
  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));

  const handleStartTour = () => {
    localStorage.removeItem('hasSeenTour');
    notifyTourStatusChange('hasSeenTour');
    setState({
      stepIndex: 0,
      tourActive: true,
      run: false,
    });
  };

  return (
    <>
      <QuickSectionStyle>
        <BannerBlock>
          <div className="text-box">
            <h1>Welcome {user?.data?.fullName} !</h1>
            <p>Ready to pick up where you left off? Jump straight into your next move.</p>
            <Button width="200px" outline onClick={handleStartTour}>
              View Walkthrough Again
            </Button>
          </div>
          <div className="img-box">
            <img src={bannerImg} alt="img" />
          </div>
        </BannerBlock>
        <div className="content-wrap">
          <InfoSection />
        </div>
      </QuickSectionStyle>
    </>
  );
}

export default QuickSection;
